// Common typo path: /home → / (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/home")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
